var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGithub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 51.4187C16.4286 54.312 9.28573 51.4188 5 42.5",
    stroke: "#25282B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25 55V46.8947C25 45.399 25.4598 44.099 26.201 42.9247C26.7095 42.119 26.3613 40.976 25.4428 40.7235C17.8349 38.632 12.5 35.2692 12.5 24.1151C12.5 21.2153 13.4501 18.4889 15.1203 16.116C15.5359 15.5254 15.7437 15.2302 15.7937 14.9627C15.8437 14.6953 15.7568 14.3463 15.5831 13.6483C14.876 10.8073 14.9218 7.79047 15.983 5.07057C15.983 5.07057 18.1761 4.35605 23.1675 7.47422C24.3071 8.18617 24.8769 8.54214 25.3787 8.62177C25.8805 8.70139 26.5515 8.5346 27.8932 8.20102C29.7283 7.74487 31.619 7.49999 33.75 7.49999C35.881 7.49999 37.7717 7.74487 39.6068 8.20102C40.9485 8.5346 41.6195 8.70139 42.1212 8.62177C42.6232 8.54214 43.193 8.18617 44.3325 7.47422C49.324 4.35605 51.517 5.07057 51.517 5.07057C52.5783 7.79047 52.624 10.8073 51.917 13.6483C51.7432 14.3463 51.6563 14.6953 51.7063 14.9627C51.7563 15.2302 51.964 15.5255 52.3798 16.116C54.0498 18.4889 55 21.2153 55 24.1151C55 35.2692 49.6653 38.632 42.0573 40.7235C41.1388 40.976 40.7905 42.119 41.299 42.9247C42.0402 44.099 42.5 45.399 42.5 46.8947V55",
    stroke: "#25282B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/github.c38aaa830a158985ec3d938ed9527af2.svg";
export { ForwardRef as ReactComponent };